import yup from '../yup';

export const loginSchema = yup.object().shape({
  id: yup.string()
    .nullable()
    .required('Please enter your login ID')
    .label('Login ID'),
  password: yup.string()
    .nullable()
    .required('Please enter your password')
    .label('Password'),
  remember: yup.boolean()
    .nullable()
    .label('Remember flag'),
});
